(function($) {
    formHelper.addRule({
        form: '#form-cancel-hold',
        status: {
            SUCCESS: function() {
                this.redirect(this.data.redirectTo);
            },
            FORMERROR: function() {
                lDialog.close();
            },
            ERROR: function() {
                this.redirect('/cancel-hold/error');
            }
        }
    });
})(jQuery);

jQuery(function initHoldCancellationForm($) {
    $('#form-cancel-hold').each(function(index, el) {

        var $container = $(this);
        var $submitBtn = $container.find('.btn-submit');

        $submitBtn.click(function() {
            // Diaplay a lDialog loading shadow box
            checkValidityValue = $('#form-cancel-hold')[0].checkValidity(); // returns true/false

            if (checkValidityValue === true) {
                // Browser checkValidity is true, load loading ldialog shadow box
                launchLoadingDialog();
            }
        });
    });
});